var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 158,
    viewBox: "0 0 190 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2539 0.25L11.4961 15.2617C11.6392 24.133 18.8717 31.25 27.7441 31.25H162.424C171.366 31.2498 178.627 24.025 178.673 15.083L178.749 0.25H189.75V149.5C189.75 153.78 186.28 157.25 182 157.25H8C3.71979 157.25 0.25 153.78 0.25 149.5V0.25H11.2539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2539 0.25L11.4961 15.2617C11.6392 24.133 18.8717 31.25 27.7441 31.25H162.424C171.366 31.2498 178.627 24.025 178.673 15.083L178.749 0.25H189.75V149.5C189.75 153.78 186.28 157.25 182 157.25H8C3.71979 157.25 0.25 153.78 0.25 149.5V0.25H11.2539Z",
    fill: "url(#paint0_linear_2518_3170)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2539 0.25L11.4961 15.2617C11.6392 24.133 18.8717 31.25 27.7441 31.25H162.424C171.366 31.2498 178.627 24.025 178.673 15.083L178.749 0.25H189.75V149.5C189.75 153.78 186.28 157.25 182 157.25H8C3.71979 157.25 0.25 153.78 0.25 149.5V0.25H11.2539Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2518_3170",
    x1: 95,
    y1: 0,
    x2: 95,
    y2: 157.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608402,
    stopColor: "#EDF5FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFront);
export default __webpack_public_path__ + "static/media/folder-front.d1a3f9224a3aaf60062d0d3a020e4466.svg";
export { ForwardRef as ReactComponent };